const style = {
  chatsContainer: {
    width: "100%",
    height: "100%",
    background: "#1e212b",
    borderRight: "1px solid #2a2f3b",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  },
  chatsHeader: {
    padding: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
    borderBottom: "1px solid #2a2f3b",
  },
  headerTitleWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start"
  },
  chatsHeaderTitle: {
    fontSize: "22px",
    fontWeight: "600",
    color: "white",
    margin: "0",
  },
  chatsHeaderSubtitle: {
    fontSize: "14px",
    color: "#aeb9c4",
  },
  headerActions: {
    display: "flex",
    gap: "10px",
  },
  iconButton: {
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    color: "#aeb9c4",
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  panel: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    flexShrink: 0,
  },
  searchWrapper: {
    position: "relative",
  },
  searchIcon: {
    position: "absolute",
    left: "15px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#aeb9c4",
  },
  searchInput: {
    width: "100%",
    height: "45px",
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    padding: "0 20px 0 45px",
    boxSizing: "border-box",
    color: "#FFF",
    fontSize: "14px",
    outline: "none",
  },
  agentSelect: {
    width: "100%",
    height: "45px",
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    borderRadius: "12px",
    padding: "0 15px",
    boxSizing: "border-box",
    color: "#FFF",
    fontSize: "14px",
    cursor: "pointer",
    outline: "none",
  },
  chatsBody: {
    flexGrow: 1,
    overflowY: "auto",
  },
  messageCenter: {
    color: "#aeb9c4",
    textAlign: "center",
    marginTop: "40px",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 20px",
    boxSizing: "border-box",
    borderTop: "1px solid #2a2f3b",
    flexShrink: 0,
  },
  paginationButton: {
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    color: "#aeb9c4",
    boxSizing: "border-box",
    padding: "8px 12px",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  disabledButton: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  paginationView: {
    color: "#aeb9c4",
    fontSize: "14px",
    fontWeight: "500",
  },
  activeButton: {
    background: "#3c4257",
    border: "1px solid #4a5268",
    color: "#FFF",
  },
  ellipsis: {
    color: "#aeb9c4",
    padding: "8px 12px",
    
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
  },
};

export default style;
